import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stFilterOnName',
  standalone: true,
})
export class FilterOnNamePipe implements PipeTransform {

  transform(value: any[], name: string): any[] {
    let finalResult: any[] = []

    finalResult = value.filter(x=> x.name.toLowerCase().includes(name.toLowerCase()));

    return finalResult;
  }

}
